/**
 * Small status pill: Active / Archived / Deleted.
 * Used in admin tables to surface a record's archive state at a glance.
 */
import { Archive, CheckCircle2, Trash2 } from "lucide-react";

const STYLES = {
  active:   { bg: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: CheckCircle2, label: "Active" },
  archived: { bg: "bg-amber-50 text-amber-800 border-amber-200",     icon: Archive,       label: "Archived" },
  deleted:  { bg: "bg-rose-50 text-rose-700 border-rose-200",        icon: Trash2,        label: "Deleted" },
};

export function StatusBadge({ status = "active", testId }) {
  const cfg = STYLES[status] || STYLES.active;
  const Icon = cfg.icon;
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-semibold uppercase tracking-wide ${cfg.bg}`}
    >
      <Icon className="w-3 h-3" />
      {cfg.label}
    </span>
  );
}

export default StatusBadge;
